<template>
    <v-data-table
        :headers="headers"
        :items="list">
        <template v-slot:item.discount_type="{ item }">
            <span>{{ discountTypes[item.discount_type].label }}</span>
        </template>
    </v-data-table>
</template>

<script>
    import discountTypes from '@/helpers/discountTypes'

    export default {
        name: "Items",
        props: ["list"],
        computed: {
            discountTypes() {
                return discountTypes
            },
            headers() {
                return [
                    {
                        text: this.$t('steps.offer.product'),
                        value: "product." + this.$locale
                    },
                    {
                        text: this.$t('steps.offer.prices.unit.net'),
                        value: "price"
                    },
                    {
                        text: this.$t('steps.offer.amount'),
                        value: "amount"
                    },
                    {
                        text: this.$t('steps.offer.discountType'),
                        value: "discount_type"
                    },
                    {
                        text: this.$t('steps.offer.discount'),
                        value: "discount"
                    },
                    {
                        text: this.$t('steps.offer.prices.total.netwd'),
                        value: "total"
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
